var map = {
	"./WAIT.png": 8848,
	"./chicken.png": 262,
	"./一台花.png": 4550,
	"./一般高.png": 5481,
	"./三姊妹.png": 4437,
	"./三相逢.png": 9047,
	"./三般高.png": 6057,
	"./二兄弟.png": 467,
	"./二姊妹.png": 8694,
	"./二暗刻.png": 919,
	"./二相逢.png": 7302,
	"./五同順.png": 269,
	"./五姊妹.png": 2257,
	"./五門齊.png": 7353,
	"./假獨.png": 7337,
	"./全帶么.png": 9004,
	"./全帶混么.png": 5467,
	"./十三么.png": 6804,
	"./十六不搭.png": 983,
	"./嚦咕嚦咕.png": 6643,
	"./四同順.png": 7222,
	"./四姊妹.png": 1697,
	"./四歸一.png": 3563,
	"./四歸二.png": 3062,
	"./四歸四.png": 1883,
	"./四般高.png": 7241,
	"./大三兄弟.png": 4889,
	"./將眼.png": 3818,
	"./對碰.png": 5005,
	"./小三兄弟.png": 3201,
	"./小三姊妹.png": 875,
	"./小五姊妹.png": 4013,
	"./小四姊妹.png": 889,
	"./平胡.png": 736,
	"./明雜龍.png": 1137,
	"./明龍.png": 2517,
	"./混么.png": 7954,
	"./清么.png": 342,
	"./獨獨.png": 8485,
	"./缺一門.png": 5301,
	"./花胡.png": 8126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8930;